/* ---- scroll reveal ---- */
const rv = document.querySelectorAll('.rv');
if ('IntersectionObserver' in window) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  rv.forEach(el => io.observe(el));
} else { rv.forEach(el => el.classList.add('in')); }

/* ---- sticky header ---- */
const hdr = document.querySelector('.hdr');
const hero = document.querySelector('.hero, .pdp-top');
if (hdr) {
  const marquee = document.querySelector('.marquee');
  const mh = marquee ? marquee.offsetHeight : 38;
  document.documentElement.style.setProperty('--marquee-h', mh + 'px');
  const hasHero = !!document.querySelector('.hero');
  const onScroll = () => {
    const y = window.scrollY;
    hdr.classList.toggle('is-top', y > mh * 0.6);
    // pages without a hero have no dark image behind the bar — keep it solid always
    hdr.classList.toggle('is-stuck', hasHero ? y > window.innerHeight * 0.78 : true);
  };
  onScroll();
  addEventListener('scroll', onScroll, { passive: true });
}

/* ---- pdp gallery ---- */
const thumbs = document.querySelectorAll('.gal__thumb');
const mainImg = document.querySelector('.gal__main img');
thumbs.forEach(t => t.addEventListener('click', () => {
  thumbs.forEach(x => x.classList.remove('is-active'));
  t.classList.add('is-active');
  mainImg.src = t.dataset.full;
  mainImg.classList.toggle('is-contain', t.dataset.fit === 'contain');
  mainImg.style.animation = 'none'; void mainImg.offsetWidth; mainImg.style.animation = '';
}));

/* ---- note pyramid link-up ---- */
const bands = document.querySelectorAll('.pyr__band');
const rows  = document.querySelectorAll('.pyr__row');
function setNote(key) {
  bands.forEach(b => { const on = b.dataset.note === key; b.classList.toggle('is-active', on); b.classList.toggle('is-dim', !on); });
  rows.forEach(r => r.classList.toggle('is-active', r.dataset.note === key));
}
function clearNote() { bands.forEach(b => b.classList.remove('is-active', 'is-dim')); rows.forEach(r => r.classList.remove('is-active')); }
bands.forEach(b => { b.addEventListener('mouseenter', () => setNote(b.dataset.note)); b.addEventListener('mouseleave', clearNote); });
rows.forEach(r => { r.addEventListener('mouseenter', () => setNote(r.dataset.note)); r.addEventListener('mouseleave', clearNote); });

/* ---- qty ---- */
document.querySelectorAll('.qty').forEach(q => {
  const inp = q.querySelector('input');
  q.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
    const v = parseInt(inp.value, 10) || 1;
    inp.value = Math.max(1, b.dataset.step === '+' ? v + 1 : v - 1);
  }));
});

/* ---- background video: honour reduced-motion, give a pause control ---- */
const reduce = matchMedia('(prefers-reduced-motion: reduce)');
// Scope to <video>. Dawn's announcement-bar slider also carries data-autoplay,
// and calling .play() on that div threw a TypeError that killed the rest of
// this file — taking hero autoplay, the reels and the lightbox down with it.
document.querySelectorAll('video[data-autoplay]').forEach(v => {
  if (reduce.matches) { v.removeAttribute('autoplay'); v.pause(); return; }
  v.play().catch(() => {});               // ignore autoplay rejection, poster stays
});

document.querySelectorAll('.vtoggle').forEach(btn => {
  const vid = document.querySelector(btn.dataset.target);
  if (!vid) return;
  const label = btn.querySelector('span');
  const icons = { pause: '<svg viewBox="0 0 24 24"><rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/></svg>',
                  play:  '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>' };
  const sync = () => {
    const playing = !vid.paused;
    btn.querySelector('i').innerHTML = playing ? icons.pause : icons.play;
    label.textContent = playing ? 'Pause' : 'Play';
    btn.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
  };
  btn.addEventListener('click', () => { vid.paused ? vid.play() : vid.pause(); sync(); });
  vid.addEventListener('play', sync); vid.addEventListener('pause', sync);
  sync();
});

/* ---- reels: lift + play ----
   Browsers refuse unmuted playback until the page has real user activation, and
   a hover does NOT count. So: hover lifts the tile and plays it silently; a
   click unmutes (a click IS activation). On touch there is no hover, so the
   first tap plays with sound and a second tap follows the link. */
const reels = document.querySelectorAll('.reel[data-video]');

/* first real gesture anywhere unlocks audio for the rest of the visit */
window.qasidaActivated = false;
['pointerdown', 'keydown', 'touchstart'].forEach(ev =>
  addEventListener(ev, () => { window.qasidaActivated = true; }, { once: true, passive: true }));

const canHover = matchMedia('(hover: hover) and (pointer: fine)').matches;

function setSoundIcon(tile, on) {
  const m = tile.querySelector('.icon-muted'), sn = tile.querySelector('.icon-sound');
  if (m && sn) { m.style.display = on ? 'none' : ''; sn.style.display = on ? '' : 'none'; }
}

function stopReels(except) {
  reels.forEach(t => {
    if (t === except) return;
    const v = t.querySelector('video'); if (!v) return;
    t.classList.remove('is-playing');
    v.pause(); v.currentTime = 0; v.muted = true; setSoundIcon(t, false);
  });
}

reels.forEach(tile => {
  const v = tile.querySelector('video');
  const btn = tile.querySelector('.reel__sound');
  if (!v) return;

  function play(withSound) {
    stopReels(tile);
    tile.classList.add('is-playing');
    v.muted = !withSound;
    setSoundIcon(tile, !!withSound);
    v.play().catch(() => {                 // refused: fall back to silent
      v.muted = true; setSoundIcon(tile, false);
      v.play().catch(() => {});
    });
  }
  function stop() {
    tile.classList.remove('is-playing');
    v.pause(); v.currentTime = 0; v.muted = true; setSoundIcon(tile, false);
  }

  if (canHover && !reduce.matches) {
    // Browsers only allow unmuted playback once the page has had a user
    // gesture. qasidaActivated tracks that, so hover plays WITH sound as soon
    // as the visitor has clicked anywhere; before that it falls back to silent
    // and shows the speaker control.
    tile.addEventListener('mouseenter', () => play(window.qasidaActivated === true));
    tile.addEventListener('mouseleave', stop);
    tile.addEventListener('focusin',  () => play(window.qasidaActivated === true));
    tile.addEventListener('focusout', stop);
  }
  tile._qasidaPlaySilent = () => play(false);
  tile._qasidaStop = stop;

  // A click opens the film full-screen WITH SOUND. Autoplay policy blocks
  // unmuted playback without a user gesture, and hover is not a gesture — a
  // click is, which is why the lightbox can reliably come up with audio on.
  tile.addEventListener('click', e => {
    if (e.target.closest('.reel__sound')) return;
    e.preventDefault();
    stop();
    QasidaLightbox.open(tile);
  });

  if (btn) btn.addEventListener('click', e => {
    e.preventDefault(); e.stopPropagation();
    v.muted = !v.muted;
    setSoundIcon(tile, !v.muted);
    v.play().catch(() => {});
  });
});

/* On touch there is no hover, so the reels never played at all — the row just
   sat there as stills. Play them silently while they are on screen; sound is
   what the lightbox is for. */
if (!canHover && !reduce.matches && 'IntersectionObserver' in window) {
  const rio = new IntersectionObserver(es => es.forEach(e => {
    const t = e.target;
    if (e.isIntersecting) { if (t._qasidaPlaySilent) t._qasidaPlaySilent(); }
    else { if (t._qasidaStop) t._qasidaStop(); }
  }), { threshold: 0.55 });
  reels.forEach(r => rio.observe(r));
}

/* ---- serve the vertical cut on portrait screens, horizontal on desktop ---- */
const mqPortrait = matchMedia('(max-width: 860px)');
function pickCut() {
  document.querySelectorAll('video[data-src-h]').forEach(v => {
    const p = mqPortrait.matches;
    const src = (p && v.dataset.srcV) ? v.dataset.srcV : v.dataset.srcH;
    const pos = (p && v.dataset.posterV) ? v.dataset.posterV : v.dataset.posterH;
    if (pos) v.poster = pos;
    if (v.dataset.current === src) return;
    v.dataset.current = src;
    const wasPlaying = !v.paused;
    v.src = src; v.load();
    // play() called straight after load() is aborted by the pending load, and
    // the rejection was being swallowed — so nothing ever autoplayed. Wait
    // until there is actually data to play.
    if (wasPlaying || v.hasAttribute('data-autoplay')) {
      // load() resets readyState ASYNCHRONOUSLY, so reading it on the next
      // line returns the previous source's value. The old code trusted that,
      // called play() immediately, and the pending load aborted it straight
      // into a swallowed catch — which is why nothing autoplayed. Wait for a
      // real data event instead, and keep listening until one play sticks.
      let started = false;
      const go = () => {
        if (started || !v.paused) return;
        v.muted = true;
        v.play().then(() => {
          started = true;
          ['loadeddata', 'canplay', 'canplaythrough'].forEach(e => v.removeEventListener(e, go));
        }).catch(() => {});
      };
      ['loadeddata', 'canplay', 'canplaythrough'].forEach(e => v.addEventListener(e, go));
      setTimeout(go, 1200);   // last resort if no event lands
    }
  });
}
pickCut();
mqPortrait.addEventListener('change', pickCut);

/* ---- campaign film tiles: hover to play, same contract as the reels ---- */
const filmTiles = document.querySelectorAll('.film[data-video]');
filmTiles.forEach(f => {
  const v = f.querySelector('video');
  if (!v || reduce.matches) return;
  const start = () => { f.classList.add('is-playing'); v.play().catch(() => {}); };
  const stop  = () => { f.classList.remove('is-playing'); v.pause(); v.currentTime = 0; };
  if (canHover) {
    f.addEventListener('mouseenter', start); f.addEventListener('mouseleave', stop);
    f.addEventListener('focusin', start);    f.addEventListener('focusout', stop);
  }
});
if (!canHover && !reduce.matches && 'IntersectionObserver' in window) {
  const fio = new IntersectionObserver(es => es.forEach(e => {
    const v = e.target.querySelector('video'); if (!v) return;
    if (e.isIntersecting) { e.target.classList.add('is-playing'); v.play().catch(()=>{}); }
    else { e.target.classList.remove('is-playing'); v.pause(); }
  }), { threshold: 0.55 });
  filmTiles.forEach(f => fio.observe(f));
}


/* ---- reel carousel: arrows, edge state, and pause when scrolled away ---- */
document.querySelectorAll('.reelwrap').forEach(wrap => {
  const track = wrap.querySelector('.reels');
  const prev  = wrap.querySelector('.reelwrap__arrow--prev');
  const next  = wrap.querySelector('.reelwrap__arrow--next');
  if (!track) return;

  const step = () => {
    const tile = track.querySelector('.reel');
    const gap  = parseFloat(getComputedStyle(track).gap) || 16;
    return tile ? (tile.getBoundingClientRect().width + gap) * 2 : track.clientWidth * 0.8;
  };
  const sync = () => {
    const max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  };

  prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  next?.addEventListener('click', () => track.scrollBy({ left:  step(), behavior: 'smooth' }));
  track.addEventListener('scroll', () => {
    sync();
    // a tile dragged out of view shouldn't keep talking
    track.querySelectorAll('.reel.is-playing').forEach(t => {
      const r = t.getBoundingClientRect(), w = track.getBoundingClientRect();
      if (r.right < w.left + 40 || r.left > w.right - 40) {
        const v = t.querySelector('video');
        t.classList.remove('is-playing');
        if (v) { v.pause(); v.currentTime = 0; v.muted = true; }
      }
    });
  }, { passive: true });
  addEventListener('resize', sync);
  sync();
});


/* ---- carousel: move while the cursor sits near either edge ---- */
document.querySelectorAll('.reelwrap').forEach(wrap => {
  const track = wrap.querySelector('.reels');
  if (!track || matchMedia('(hover: none)').matches || reduce.matches) return;

  const EDGE = 0.16;     // how much of the width counts as an edge zone
  const MAX  = 16;       // px per frame at the very edge
  let vel = 0, frame = null;

  const canL = () => track.scrollLeft > 2;
  const canR = () => track.scrollLeft < track.scrollWidth - track.clientWidth - 2;

  function tick() {
    if (!vel) { frame = null; return; }
    track.scrollLeft += vel;
    wrap.classList.toggle('can-l', canL());
    wrap.classList.toggle('can-r', canR());
    frame = requestAnimationFrame(tick);
  }

  wrap.addEventListener('mousemove', e => {
    const r = track.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width;
    if (x < EDGE)            vel = -MAX * (1 - x / EDGE);          // ramps with proximity
    else if (x > 1 - EDGE)   vel =  MAX * ((x - (1 - EDGE)) / EDGE);
    else                     vel = 0;
    if (vel && !canL() && vel < 0) vel = 0;
    if (vel && !canR() && vel > 0) vel = 0;
    if (vel && !frame) frame = requestAnimationFrame(tick);
  });

  wrap.addEventListener('mouseleave', () => { vel = 0; wrap.classList.remove('can-l','can-r'); });
  wrap.addEventListener('mouseenter', () => {
    wrap.classList.toggle('can-l', canL());
    wrap.classList.toggle('can-r', canR());
  });
});

/* ============================================================
   SIZE / VARIANT PICKER
   Swaps the hidden variant id, the headline price and the
   add-to-bag label. Out-of-stock sizes are disabled server-side.
   ============================================================ */
document.querySelectorAll('[data-variants]').forEach(function (group) {
  var opts     = group.querySelectorAll('.vopt');
  var nameEl   = group.querySelector('[data-variant-name]');
  var input    = document.querySelector('[data-variant-input]');
  var priceEl  = document.querySelector('[data-price]');
  var addBtn   = document.querySelector('[data-add]');
  var addLabel = document.querySelector('[data-add-label]');

  opts.forEach(function (o) {
    o.addEventListener('click', function () {
      if (o.disabled) return;
      opts.forEach(function (x) { x.classList.remove('is-active'); });
      o.classList.add('is-active');

      if (input)   input.value = o.dataset.vid;
      if (nameEl)  nameEl.textContent = o.dataset.title;
      if (priceEl) priceEl.textContent = o.dataset.price;

      var available = o.dataset.available === 'true';
      if (addBtn) addBtn.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to bag — ' + o.dataset.price : 'Sold out';

      // keep the URL shareable / back-button friendly
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', o.dataset.vid);
        history.replaceState({}, '', u);
      }
    });
  });
});


/* ============================================================
   VIDEO LIGHTBOX
   Click a reel or campaign tile and it opens full-screen and plays
   with sound. A click is real user activation, so unmuted playback
   is allowed here in a way it never is on hover.
   ============================================================ */
var QasidaLightbox = (function () {
  var box, stage, video, capEl, linkEl, prevBtn, nextBtn;
  var items = [], index = 0, lastFocus = null;

  function collect() {
    items = [].slice.call(document.querySelectorAll('.reel[data-video], .film[data-video]'));
  }

  function srcFor(tile) {
    var v = tile.querySelector('video');
    if (!v) return null;
    var portrait = matchMedia('(max-width: 860px)').matches;
    return (portrait && v.dataset.srcV) ? v.dataset.srcV : (v.dataset.srcH || v.dataset.srcV);
  }

  function build() {
    box = document.createElement('div');
    box.className = 'vbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Video');
    box.innerHTML =
      '<button class="vbox__close" type="button" aria-label="Close video">&times;</button>' +
      '<button class="vbox__nav vbox__nav--prev" type="button" aria-label="Previous video">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<div class="vbox__stage">' +
        '<video class="vbox__video" playsinline controls preload="auto"></video>' +
        '<div class="vbox__meta">' +
          '<p class="vbox__cap"></p>' +
          '<a class="vbox__link btn btn--ghost-light" href="#"><span>View the fragrance</span></a>' +
        '</div>' +
      '</div>' +
      '<button class="vbox__nav vbox__nav--next" type="button" aria-label="Next video">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>';
    document.body.appendChild(box);

    stage   = box.querySelector('.vbox__stage');
    video   = box.querySelector('.vbox__video');
    capEl   = box.querySelector('.vbox__cap');
    linkEl  = box.querySelector('.vbox__link');
    prevBtn = box.querySelector('.vbox__nav--prev');
    nextBtn = box.querySelector('.vbox__nav--next');

    box.querySelector('.vbox__close').addEventListener('click', close);
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
    // click the backdrop (not the video or its chrome) to dismiss
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target === stage) close();
    });
    addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
  }

  function show(i) {
    index = (i + items.length) % items.length;
    var tile = items[index];
    var src  = srcFor(tile);
    if (!src) return;

    video.src = src;
    video.currentTime = 0;
    video.muted = false;
    video.volume = 1;

    var cap = tile.querySelector('.reel__cap, .film__in h3');
    capEl.textContent = cap ? cap.textContent.trim() : '';
    capEl.style.display = capEl.textContent ? '' : 'none';

    var href = tile.getAttribute('href');
    if (href && href !== '#') { linkEl.href = href; linkEl.style.display = ''; }
    else { linkEl.style.display = 'none'; }

    var many = items.length > 1;
    prevBtn.style.display = many ? '' : 'none';
    nextBtn.style.display = many ? '' : 'none';

    video.play().catch(function () {
      // a browser that still refuses audio: play silently rather than nothing,
      // and let the visitor unmute from the native controls
      video.muted = true;
      video.play().catch(function () {});
    });
  }

  function step(d) { show(index + d); }

  function open(tile) {
    if (!box) build();
    collect();
    var i = items.indexOf(tile);
    lastFocus = document.activeElement;
    box.classList.add('is-open');
    document.documentElement.classList.add('vbox-open');
    show(i < 0 ? 0 : i);
    box.querySelector('.vbox__close').focus();
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    document.documentElement.classList.remove('vbox-open');
    video.pause();
    video.removeAttribute('src');
    video.load();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  return { open: open, close: close };
})();

/* campaign film tiles open the lightbox too */
document.querySelectorAll('.film[data-video]').forEach(function (tile) {
  tile.addEventListener('click', function (e) {
    e.preventDefault();
    QasidaLightbox.open(tile);
  });
});
